/**
 * @description 해당 오브젝트에 대한 key 유효성 검사.
 * @param { JSON Object } object
 * @param { String } key
 * @returns { Boolean } return
 */
export const hasProperty = (object, key) => {
  if (!object) {
    return false;
  } else {
    return Object.keys(object).includes(key);
  }
};

/**
 * @description 해당 오브젝트에 key 에 해당 하는 value 값 추출 (만약 key 값이 없을 시. defaultValue 반환).
 * @param { JSON Object } object
 * @param { String } key
 * @param { any } defaultValue
 * @returns { Boolean } return
 */
export const getValue = (object, key, defaultValue) => {
  if (hasProperty(object, key)) {
    return object[key] ? object[key] : defaultValue;
  } else {
    return defaultValue;
  }
};

export const integerFormatter = (number) => {
  return Math.floor(valueValidation(number))
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const floatFormatter = (number, fix = 2) => {
  if (number) {
    return valueValidation(number)
      .toFixed(fix)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return '0.00';
  }
};

export const percentFormatter = (number) => {
  return floatFormatter(number, 2) + '%';
};

export const currencyFormatter = (number) => {
  return (
    '$' +
    Number.parseFloat(valueValidation(number).toString())
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  );
};

export const integerCustomFormatter = (number, customUnit) => {
  return (
    valueValidation(number)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',') + customUnit
  );
};

export const floatCustomFormatter = (number, fix, customUnit) => {
  return (
    Number.parseFloat(valueValidation(number).toString())
      .toFixed(fix)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',') + customUnit
  );
};

function valueValidation(number) {
  let value = 0;
  if (typeof number !== 'undefined' && number !== null) {
    if (hasProperty(number, 'value')) {
      value = getValue(number, 'value', 0);
    } else {
      value = number;
    }
  }

  return value;
}

/**
 * @description 패스워드 -> * 로 보여주는것만 변환 함수
 * @param {*} string
 * @returns
 */
export const getPasswordString = (string) => {
  const stringLength = string.trim().length;
  if (stringLength > 0) {
    return Array.from(Array(stringLength).keys()).map((item) => '*');
  } else {
    return '';
  }
};
